import { TemplateRef } from '@angular/core';

type ActionType = 'button' | 'icon' | 'menu';

export interface MenuItem {
  id: string;
  label: string;
  icon?: string;
  disabled?: boolean;
  visible?: boolean;
}

export interface TableAction {
  id: string;
  label?: string;
  type?: ActionType;
  icon?: string;
  color?: 'primary' | 'accent' | 'warn';
  tooltip?: string;
  disabled?: boolean;
  visible?: boolean;
  class?: string;
  iconClass?: string;
  menuItems?: MenuItem[];
  menuContentTemplate?: TemplateRef<unknown>;
  iconColor?: string;
}
